const testimonials = [
  {
    body: "At Integral, we actively seek out diverse perspectives. Through our partnership with WattleNest and the support we provide Sarah, we are helping to create better outcomes. Sarah is testament that if you continue to persevere, you can achieve greatness.",
    author: {
      name: "Integral",
      handle: "Sponsor",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "It's an absolute privilege for me to partner with the WattleNest and a company like Integral, that values innovation, creativity, and diversity. The support I receive through this partnership will go a long way in helping me achieve my competition goals for this year, and allow me to spend more time focussing on my training and community work.",
    author: {
      name: "Sarah Larcombe",
      handle: "Para Climbing",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "We are proud to partner with the WattleNest and know our involvement will help transform the support provided to athletes. We are committed to contributing to supporting our communities.",
    author: {
      name: "Aurizon",
      handle: "Sponsor",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "We are a business powered by athletes and love knowing we can help our talent with their journey. By investing in the WattleNest, we know we are contributing to building stronger communities through sport.",
    author: {
      name: "Sarah Bryden",
      handle: "Echelon Legal",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "At Governance By Design we believe in leadership from the boardroom. We also believe athletes demonstrate the leadership qualities that can bring greater strength to businesses. We are proud to be in a position to support Janine navigate part 2 of her Paralympic dream and know that our investment has genuinely made a positive difference.",
    author: {
      name: "Governance by Design",
      handle: "Sponsor",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "I am blown away by the support the WattleNest has provided athletes including myself.The financial and emotional support they have provided me has removed very real barriers allowing me to focus on the things that matter most to be the best I can be without focussing on the financial stress of competing, training and recovery.",
    author: {
      name: "Jess Borg",
      handle: "Australian Taekwondo Representative",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "WattleNest took the time to understand the pressures and challenges of what it takes for me to be an elite athlete. Rachel compassionately listened to my story and what I valued and used the fantastic network she created to try and ease some of the financial burdens I face as elite athlete.",
    author: {
      name: "Janine Watson PLY",
      handle: "Australian Paralympian",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "The WattleNest gives athletes an opportunity to connect to people and companies and attain financial support whilst doing so. Rachel has created a new concept and very needed help for Olympic and Paralympic disciplined athletes. I look forward to welcoming Echelon Legal on the journey.",
    author: {
      name: "Abbey Wilcox",
      handle: "Aerial Skiing",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "I am so grateful for the support Wattlenest and Caliba Group have provided to me over the last couple of years & especially now as I get ready to transition into a new chapter of motherhood & soon embark on the challenge of making my way back to the sandpit. There is something really powerful beyond financial support that comes along with being part of the Wattlenest Community- Their support is unconditional through all the highs and lows that both sport and life can throw at you. When I wasn't performing to my full potential, their support & belief was always there. It was quite transformative for me to be honest and it came when I needed it the most.",
    author: {
      name: "Brooke Buschkuehl OLY",
      handle: "Long Jump",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "I extend my deepest gratitude to those who have and will rally behind me and the WattleNest as I embark on this quest. I hope together we can make changed I can potentially be a catalyst to inspire countless others, especially those with a disability.",
    author: {
      name: "Jeremy Peacock PLY",
      handle: "Para Triathlete",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "As a business we are deeply connected to investing in regional Australia and WattleNest have given us another platform to do so. It's great to see talent from rural and regional communities get the opportunity to represent Australia in the big smoke",
    author: {
      name: "Morgans Financial",
      handle: "Corporate Partner",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  {
    body: "WattleNest makes the dream real. Their support was not just for me, it was for my team mates, my coaching team and my community.",
    author: {
      name: "Gout Gout",
      handle: "Athlete",
      imageUrl:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
];

export default function Example() {
  return (
    <div className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-base/7 font-semibold text-gold">Testimonials</h2>
          <p className="mt-2 text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">
            Hear from members of the WattleNest community
          </p>
        </div>
        <div className="mx-auto mt-16 flow-root max-w-2xl sm:mt-20 lg:mx-0 lg:max-w-none">
          <div className="-mt-8 sm:-mx-4 sm:columns-2 sm:text-[0] lg:columns-3">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.author.handle}
                className="pt-8 sm:inline-block sm:w-full sm:px-4"
              >
                <figure className="rounded-2xl bg-goldlight p-8 text-sm/6">
                  <blockquote className="text-gray-900">
                    <p>{`“${testimonial.body}”`}</p>
                  </blockquote>
                  <figcaption className="mt-6 flex items-center gap-x-4">
                    {/* <img
                      alt=""
                      src={testimonial.author.imageUrl}
                      className="size-10 rounded-full bg-gray-50"
                    /> */}
                    <div>
                      <div className="font-semibold text-gray-900">
                        {testimonial.author.name}
                      </div>
                      <div className="text-gray-600">{`${testimonial.author.handle}`}</div>
                    </div>
                  </figcaption>
                </figure>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
